
import Vue from 'vue'
export default Vue.extend({
  props: {
    color: {
      type: String,
      default: '#828282',
      required: false,
    },
  },
})
